import './carousel-swiper.css'

import SwiperCarouselInstance from 'customs/swiper-carousel'
import { getData } from 'helpers/dom'

const AXIS_LOCK_THRESHOLD = 6

class CarouselSwiperCustom extends HTMLElement {
  connectedCallback() {
    // FLICKER FIX: Initialize in connectedCallback instead of constructor
    // This ensures the element is fully attached to DOM before initialization
    const config = JSON.parse(getData('config', this))
    const options = JSON.parse(getData('options', this))

    // Small delay to ensure Swiper library is loaded
    requestAnimationFrame(() => {
      const carousel = new SwiperCarouselInstance(this, options, config)
      this.setupTouchAxisLock(options)
    })
  }

  disconnectedCallback() {
    this.teardownTouchAxisLock()
  }

  /**
   * Locks scroll to one axis per gesture so a mostly-horizontal slide swipe
   * does not also scroll the page vertically (common after disabling freeMode).
   */
  setupTouchAxisLock(options) {
    if (options?.direction === 'vertical') return

    const swiperEl = this.querySelector('.js-carousel-swiper')
    if (!swiperEl) return

    this.teardownTouchAxisLock()

    let startX = 0
    let startY = 0
    let axis = null

    this._onTouchStart = (e) => {
      if (!e.touches?.[0]) return
      startX = e.touches[0].clientX
      startY = e.touches[0].clientY
      axis = null
    }

    this._onTouchMove = (e) => {
      if (!e.touches?.[0] || axis === 'y') return

      const dx = Math.abs(e.touches[0].clientX - startX)
      const dy = Math.abs(e.touches[0].clientY - startY)

      if (axis === null) {
        if (dx < AXIS_LOCK_THRESHOLD && dy < AXIS_LOCK_THRESHOLD) return
        // Prefer horizontal on ties — this is a horizontal carousel
        axis = dx >= dy ? 'x' : 'y'
      }

      // Once horizontal intent is clear, block page scroll for this gesture
      if (axis === 'x') {
        e.preventDefault()
      }
    }

    this._onTouchEnd = () => {
      axis = null
    }

    this._touchAxisLockEl = swiperEl
    swiperEl.addEventListener('touchstart', this._onTouchStart, { passive: true })
    swiperEl.addEventListener('touchmove', this._onTouchMove, { passive: false })
    swiperEl.addEventListener('touchend', this._onTouchEnd, { passive: true })
    swiperEl.addEventListener('touchcancel', this._onTouchEnd, { passive: true })
  }

  teardownTouchAxisLock() {
    const swiperEl = this._touchAxisLockEl
    if (!swiperEl) return

    swiperEl.removeEventListener('touchstart', this._onTouchStart)
    swiperEl.removeEventListener('touchmove', this._onTouchMove)
    swiperEl.removeEventListener('touchend', this._onTouchEnd)
    swiperEl.removeEventListener('touchcancel', this._onTouchEnd)

    this._touchAxisLockEl = null
    this._onTouchStart = null
    this._onTouchMove = null
    this._onTouchEnd = null
  }
}

customElements.define('carousel-swiper-custom', CarouselSwiperCustom)
